import { FC, useMemo } from "react";
import { CSVLink } from "react-csv";
import { IconButton, Tooltip } from "@mui/material";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import { useAppSelector } from "../../../../../../../../store/hooks";
import { commitmentsCSVDataSelector } from "../../../../../../../../store/commitments/selectors/coverage-and-utilization/data/csv/commitmentsCSVDataSelector";
import { commitmentsCSVFileNameSelector } from "../../../../../../../../store/commitments/selectors/coverage-and-utilization/data/csv/commitmentsCSVFileNameSelector";
import { utilizationAndCoverageDatesSelector } from "../../../../../../../../store/commitments/selectors/coverage-and-utilization/view-options/utilizationAndCoverageDatesSelector";
import { organisationQuarterStartMonthSelector } from "../../../../../../../../store/common/selectors/org-current-settings/organisationQuarterStartMonthSelector";
import { calculateFromToByDatesData } from "../../../../../../../common/date-range-picker-v2/utils/helpers/calculateFromToByDatesData";

export const UtilizationAndCoverageCsvDownloader: FC = () => {
  const fileName = useAppSelector(commitmentsCSVFileNameSelector);
  const data = useAppSelector(commitmentsCSVDataSelector);
  const dates = useAppSelector(utilizationAndCoverageDatesSelector);

  const quarterStartMonth = useAppSelector(
    organisationQuarterStartMonthSelector,
  );

  const tooltip = useMemo(() => {
    const { toDate, fromDate } = calculateFromToByDatesData(
      dates,
      quarterStartMonth,
    );

    return fromDate && toDate ? `from ${fromDate} to ${toDate}` : "";
  }, [dates, quarterStartMonth]);

  if (!data) {
    return null;
  }

  return (
    <CSVLink filename={fileName} data={data}>
      <Tooltip title={`Export CSV ${tooltip}`} arrow placement="top">
        <IconButton size="medium">
          <DownloadOutlinedIcon fontSize="medium" />
        </IconButton>
      </Tooltip>
    </CSVLink>
  );
};
